<template>
  <main id="admin-settings-main">
    <div class="app-view-container">
      <el-row>
        <el-col class="app-view-title">
          {{ $t('admin.settings.title') }}
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <search-filter ref="searchFilter" />
        </el-col>
      </el-row>

      <el-row class="search-summary-container bg-white">
        <el-col>
          <el-row class="default-section-header">
            <el-col :span="6" class="default-section-title">
              {{ $t('admin.settings.summaryTitle') }}
              <el-tooltip class="item" effect="dark" :enterable="false" :content="$t('common.refresh')" placement="top-start">
                <el-button @click="handleRefresh" icon="el-icon-refresh" size="mini" class="button-action-default search-summary-refresh-button"></el-button>
              </el-tooltip>
            </el-col>
            <el-col :span="18" class="default-section-actions text-align-end">
              <import-day-of-services/>
              <send-invoices-email />
              <copy-account-consignee />
              <create-pallet-receipt></create-pallet-receipt>
              <sage-configuration-dialog></sage-configuration-dialog>
              <synchronize-shuttle-files></synchronize-shuttle-files>
              <synchronize-d-o-s></synchronize-d-o-s>
            </el-col>
          </el-row>
          <el-row class="search-summary">
            <el-col>
              <search-summary />
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </main>
</template>

<script>
import SageConfigurationDialog from '@/views/admin/settings/components/SageConfigurationDialog';
import SendInvoicesEmail from '@/views/admin/settings/components/SendInvoicesEmail';
import CreatePalletReceipt from '@/views/admin/settings/components/CreatePalletReceipt';
import SynchronizeShuttleFiles from '@/views/admin/settings/components/SynchronizeShuttleFiles';
import ImportDayOfServices from '@/views/admin/settings/components/ImportDayOfServices';
import SearchFilter from './SearchFilter';
import SearchSummary from './SearchSummary';
import SynchronizeDOS from './components/SynchronizeDOS';
import CopyAccountConsignee from './components/CopyAccountConsignee';

export default {
  name: 'AdminSettings',
  components: {
    ImportDayOfServices,
    SynchronizeShuttleFiles,
    SendInvoicesEmail,
    CreatePalletReceipt,
    SageConfigurationDialog,
    SearchFilter,
    SearchSummary,
    SynchronizeDOS,
    CopyAccountConsignee
  },
  methods: {
    handleRefresh() {
      this.$refs.searchFilter.handleSearch();
    }
  }
};
</script>
